import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, superAdminOnly = false }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#F8F9FA]">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-[#006080] border-t-transparent rounded-full animate-spin" />
          <span className="text-sm text-gray-500">Loading...</span>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Force password reset
  if (user.force_password_reset && window.location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  if (superAdminOnly && user.role !== "super_admin") return <Navigate to="/" replace />;
  if (adminOnly && !["super_admin", "company_admin"].includes(user.role)) return <Navigate to="/" replace />;

  return children;
}
